/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { GochainSwap, GochainSwapInterface } from "../GochainSwap";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_gochainOMIAddress",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "previousSwapAmount",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "newSwapAmount",
        type: "uint256",
      },
    ],
    name: "MinimumSwapAmountChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "swapId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "fromAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "fromChain",
        type: "string",
      },
      {
        indexed: false,
        internalType: "string",
        name: "toChain",
        type: "string",
      },
    ],
    name: "Swap",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "gochainOMIAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minimumSwapAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newMinimumSwapAmount",
        type: "uint256",
      },
    ],
    name: "setMinumumSwapAmount",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "toAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "swap",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040523480156200001157600080fd5b5060405162001d8238038062001d82833981810160405281019062000037919062000328565b6000600160006101000a81548160ff021916908315150217905550620000897fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c21775806200011660201b620008461760201c565b620000c07fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c21775336200017960201b620008a11760201c565b806001806101000a81548173ffffffffffffffffffffffffffffffffffffffff021916908373ffffffffffffffffffffffffffffffffffffffff160217905550670de0b6b3a764000060028190555050620003ad565b600062000129836200018f60201b60201c565b905081600080858152602001908152602001600020600101819055508181847fbd79b86ffe0ab8e8776151514217cd7cacd52c909f66475c3af44e129f0b00ff60405160405180910390a4505050565b6200018b8282620001ae60201b60201c565b5050565b6000806000838152602001908152602001600020600101549050919050565b620001c082826200029f60201b60201c565b6200029b57600160008084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff021916908315150217905550620002406200030960201b60201c565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45b5050565b600080600084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b600033905090565b600081519050620003228162000393565b92915050565b6000602082840312156200034157620003406200038e565b5b6000620003518482850162000311565b91505092915050565b600062000367826200036e565b9050919050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b600080fd5b6200039e816200035a565b8114620003aa57600080fd5b50565b6119c580620003bd6000396000f3fe608060405234801561001057600080fd5b50600436106100f55760003560e01c806375b238fc11610097578063d004f0f711610066578063d004f0f71461024e578063d180e5d21461026a578063d547741f14610286578063ff536fc4146102a2576100f5565b806375b238fc146101d85780638456cb59146101f657806391d1485414610200578063a217fddf14610230576100f5565b80632f2ff15d116100d35780632f2ff15d1461017857806336568abe146101945780633f4ba83a146101b05780635c975abb146101ba576100f5565b806301ffc9a7146100fa578063200ab15d1461012a578063248a9ca314610148575b600080fd5b610114600480360381019061010f9190611016565b6102c0565b6040516101219190611315565b60405180910390f35b61013261033a565b60405161013f919061144d565b60405180910390f35b610162600480360381019061015d9190610fa9565b610340565b60405161016f9190611330565b60405180910390f35b610192600480360381019061018d9190610fd6565b61035f565b005b6101ae60048036038101906101a99190610fd6565b610388565b005b6101b861040b565b005b6101c2610448565b6040516101cf9190611315565b60405180910390f35b6101e061045f565b6040516101ed9190611330565b60405180910390f35b6101fe610483565b005b61021a60048036038101906102159190610fd6565b6104c0565b6040516102279190611315565b60405180910390f35b61023861052a565b6040516102459190611330565b60405180910390f35b61026860048036038101906102639190610f69565b610531565b005b610284600480360381019061027f9190611043565b610749565b005b6102a0600480360381019061029b9190610fd6565b6107f9565b005b6102aa610822565b6040516102b791906112d1565b60405180910390f35b60007f7965db0b000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff191614806103335750610332826108af565b5b9050919050565b60025481565b6000806000838152602001908152602001600020600101549050919050565b61036882610340565b61037981610374610919565b610921565b61038383836109be565b505050565b610390610919565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16146103fd576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016103f49061142d565b60405180910390fd5b6104078282610a9e565b5050565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177561043d81610438610919565b610921565b610445610b7f565b50565b6000600160009054906101000a900460ff16905090565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177581565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c217756104b5816104b0610919565b610921565b6104bd610c21565b50565b600080600084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060009054906101000a900460ff16905092915050565b6000801b81565b610539610448565b15610579576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610570906113cd565b60405180910390fd5b600073ffffffffffffffffffffffffffffffffffffffff168273ffffffffffffffffffffffffffffffffffffffff1614156105e9576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016105e0906113ed565b60405180910390fd5b60025481101561062e576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610625906113ad565b60405180910390fd5b600060018054906101000a900473ffffffffffffffffffffffffffffffffffffffff1690508073ffffffffffffffffffffffffffffffffffffffff166379cc679033846040518363ffffffff1660e01b815260040161068e9291906112ec565b600060405180830381600087803b1580156106a857600080fd5b505af11580156106bc573d6000803e3d6000fd5b505050506106d66001600354610cc390919063ffffffff16565b6003819055508273ffffffffffffffffffffffffffffffffffffffff163373ffffffffffffffffffffffffffffffffffffffff166003547f28d75db896d26f6e5affec34fd4c8e6337ff2ab5d7ce1e48532295069d27eeb88560405161073c9190611468565b60405180910390a4505050565b7fa49807205ce4d355092ef5a8a18f56e8913cf4a201fbe287825b095693c2177561077b81610776610919565b610921565b600082116107be576040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016107b59061140d565b60405180910390fd5b816002547fc57c7f0e11d51c72bb581377cd8e317c1564b6de7038a80b5b0274fb1daaf27660405160405180910390a3816002819055505050565b61080282610340565b6108138161080e610919565b610921565b61081d8383610a9e565b505050565b60018054906101000a900473ffffffffffffffffffffffffffffffffffffffff1681565b600061085183610340565b905081600080858152602001908152602001600020600101819055508181847fbd79b86ffe0ab8e8776151514217cd7cacd52c909f66475c3af44e129f0b00ff60405160405180910390a4505050565b6108ab82826109be565b5050565b60007f01ffc9a7000000000000000000000000000000000000000000000000000000007bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916827bffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916149050919050565b600033905090565b61092b82826104c0565b6109ba576109508173ffffffffffffffffffffffffffffffffffffffff166014610cd9565b61095e8360001c6020610cd9565b60405160200161096f929190611297565b6040516020818303038152906040526040517f08c379a00000000000000000000000000000000000000000000000000000000081526004016109b1919061134b565b60405180910390fd5b5050565b6109c882826104c0565b610a9a57600160008084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff021916908315150217905550610a3f610919565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45b5050565b610aa882826104c0565b15610b7b57600080600084815260200190815260200160002060000160008373ffffffffffffffffffffffffffffffffffffffff1673ffffffffffffffffffffffffffffffffffffffff16815260200190815260200160002060006101000a81548160ff021916908315150217905550610b20610919565b73ffffffffffffffffffffffffffffffffffffffff168173ffffffffffffffffffffffffffffffffffffffff16837ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b60405160405180910390a45b5050565b610b87610448565b610bc6576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610bbd9061138d565b60405180910390fd5b6000600160006101000a81548160ff0219169083151502179055507f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa610c0a610919565b604051610c1791906112d1565b60405180910390a1565b610c29610448565b15610c69576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610c60906113cd565b60405180910390fd5b60018060006101000a81548160ff0219169083151502179055507f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258610cac610919565b604051610cb991906112d1565b60405180910390a1565b60008183610cd191906114d0565b905092915050565b606060006002836002610cec9190611526565b610cf691906114d0565b67ffffffffffffffff811115610d0f57610d0e6116b9565b5b6040519080825280601f01601f191660200182016040528015610d415781602001600182028036833780820191505090505b5090507f300000000000000000000000000000000000000000000000000000000000000081600081518110610d7957610d7861168a565b5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a9053507f780000000000000000000000000000000000000000000000000000000000000081600181518110610ddd57610ddc61168a565b5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a90535060006001846002610e1d9190611526565b610e2791906114d0565b90505b6001811115610ec7577f3031323334353637383961626364656600000000000000000000000000000000600f861660108110610e6957610e6861168a565b5b1a60f81b828281518110610e8057610e7f61168a565b5b60200101907effffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff1916908160001a905350600485901c945080610ec090611631565b9050610e2a565b5060008414610f0b576040517f08c379a0000000000000000000000000000000000000000000000000000000008152600401610f029061136d565b60405180910390fd5b8091505092915050565b600081359050610f2481611933565b92915050565b600081359050610f398161194a565b92915050565b600081359050610f4e81611961565b92915050565b600081359050610f6381611978565b92915050565b60008060408385031215610f8057610f7f6116e8565b5b6000610f8e85828601610f15565b9250506020610f9f85828601610f54565b9150509250929050565b600060208284031215610fbf57610fbe6116e8565b5b6000610fcd84828501610f2a565b91505092915050565b60008060408385031215610fed57610fec6116e8565b5b6000610ffb85828601610f2a565b925050602061100c85828601610f15565b9150509250929050565b60006020828403121561102c5761102b6116e8565b5b600061103a84828501610f3f565b91505092915050565b600060208284031215611059576110586116e8565b5b600061106784828501610f54565b91505092915050565b61107981611580565b82525050565b61108881611592565b82525050565b6110978161159e565b82525050565b60006110a8826114a9565b6110b281856114b4565b93506110c28185602086016115fe565b6110cb816116ed565b840191505092915050565b60006110e1826114a9565b6110eb81856114c5565b93506110fb8185602086016115fe565b80840191505092915050565b60006111146020836114b4565b915061111f826116fe565b602082019050919050565b60006111376014836114b4565b915061114282611727565b602082019050919050565b600061115a6033836114b4565b915061116582611750565b604082019050919050565b600061117d6008836114b4565b91506111888261179f565b602082019050919050565b60006111a06010836114b4565b91506111ab826117c8565b602082019050919050565b60006111c36007836114b4565b91506111ce826117f1565b602082019050919050565b60006111e66020836114b4565b91506111f18261181a565b602082019050919050565b6000611209602a836114b4565b915061121482611843565b604082019050919050565b600061122c6017836114c5565b915061123782611892565b601782019050919050565b600061124f6011836114c5565b915061125a826118bb565b601182019050919050565b6000611272602f836114b4565b915061127d826118e4565b604082019050919050565b611291816115f4565b82525050565b60006112a28261121f565b91506112ae82856110d6565b91506112b982611242565b91506112c582846110d6565b91508190509392505050565b60006020820190506112e66000830184611070565b92915050565b60006040820190506113016000830185611070565b61130e6020830184611288565b9392505050565b600060208201905061132a600083018461107f565b92915050565b6000602082019050611345600083018461108e565b92915050565b60006020820190508181036000830152611365818461109d565b905092915050565b6000602082019050818103600083015261138681611107565b9050919050565b600060208201905081810360008301526113a68161112a565b9050919050565b600060208201905081810360008301526113c68161114d565b9050919050565b600060208201905081810360008301526113e681611193565b9050919050565b60006020820190508181036000830152611406816111d9565b9050919050565b60006020820190508181036000830152611426816111fc565b9050919050565b6000602082019050818103600083015261144681611265565b9050919050565b60006020820190506114626000830184611288565b92915050565b600060608201905061147d6000830184611288565b818103602083015261148e816111b6565b905081810360408301526114a181611170565b905092915050565b600081519050919050565b600082825260208201905092915050565b600081905092915050565b60006114db826115f4565b91506114e6836115f4565b9250827fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0382111561151b5761151a61165b565b5b828201905092915050565b6000611531826115f4565b915061153c836115f4565b9250817fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff04831182151516156115755761157461165b565b5b828202905092915050565b600061158b826115d4565b9050919050565b60008115159050919050565b6000819050919050565b60007fffffffff0000000000000000000000000000000000000000000000000000000082169050919050565b600073ffffffffffffffffffffffffffffffffffffffff82169050919050565b6000819050919050565b60005b8381101561161c578082015181840152602081019050611601565b8381111561162b576000848401525b50505050565b600061163c826115f4565b915060008214156116505761164f61165b565b5b600182039050919050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b600080fd5b6000601f19601f8301169050919050565b7f537472696e67733a20686578206c656e67746820696e73756666696369656e74600082015250565b7f5061757361626c653a206e6f7420706175736564000000000000000000000000600082015250565b7f416d6f756e74206d7573742062652067726561746572207468616e207468652060008201527f6d696e696d756d207377617020616d6f756e7400000000000000000000000000602082015250565b7f657468657265756d000000000000000000000000000000000000000000000000600082015250565b7f5061757361626c653a2070617573656400000000000000000000000000000000600082015250565b7f676f636861696e00000000000000000000000000000000000000000000000000600082015250565b7f43616e206e6f74207377617020746f20746865207a65726f2061646472657373600082015250565b7f4d696e696d756d207377617020616d6f756e74206d757374206265206772656160008201527f746572207468616e203000000000000000000000000000000000000000000000602082015250565b7f416363657373436f6e74726f6c3a206163636f756e7420000000000000000000600082015250565b7f206973206d697373696e6720726f6c6520000000000000000000000000000000600082015250565b7f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560008201527f20726f6c657320666f722073656c660000000000000000000000000000000000602082015250565b61193c81611580565b811461194757600080fd5b50565b6119538161159e565b811461195e57600080fd5b50565b61196a816115a8565b811461197557600080fd5b50565b611981816115f4565b811461198c57600080fd5b5056fea26469706673582212201d80698ad474a92afac620d3a2f3e7651154d144808e70acb0aa54ee8533f89f64736f6c63430008060033";

export class GochainSwap__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    _gochainOMIAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<GochainSwap> {
    return super.deploy(_gochainOMIAddress, overrides || {}) as Promise<
      GochainSwap
    >;
  }
  getDeployTransaction(
    _gochainOMIAddress: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_gochainOMIAddress, overrides || {});
  }
  attach(address: string): GochainSwap {
    return super.attach(address) as GochainSwap;
  }
  connect(signer: Signer): GochainSwap__factory {
    return super.connect(signer) as GochainSwap__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): GochainSwapInterface {
    return new utils.Interface(_abi) as GochainSwapInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): GochainSwap {
    return new Contract(address, _abi, signerOrProvider) as GochainSwap;
  }
}
